import PageLayout from "components/layout/PageLayout";
import HealthRealtTimeCard from "./views/HealthRealtTimeCard";
import { useLazyGetHealthStatusQuery } from "./api/healthStatusApiSlice";
import { HealthMockedStatuses } from "./views/HealthMockedStatuses";
import { useEffect, useState } from "react";
import { useWebSocket } from "app/ws/WebSocketProvider";
import { selectCompanyGuid } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import NoData from "components/commons/NoData";

const HealthDashboard = () => {

    const [t] = useTranslation(["health"])

    const { connectionStatus: wsStatus, client: wsClient } = useWebSocket()
    const companyGuid = useSelector(selectCompanyGuid)
    const [autoRefresh, setAutoRefresh] = useState(true)

    const refreshSeconds = 30

    const [getStatus, {
        data: statuses,
        isLoading: statusesIsLoading,
        isSuccess: statusesIsSuccess,
    }] = useLazyGetHealthStatusQuery();


    const getStartOfDay = () => Math.floor(new Date().setHours(0, 0, 0, 0));

    useEffect(() => {
        handleRefresh(); // Recupera i dati al primo render

        if (autoRefresh) {
            const interval = setInterval(() => {
                handleRefresh()
            }, refreshSeconds * 1000);

            return () => clearInterval(interval); // Pulisce l'intervallo quando il componente si smonta
        }
    }, [getStatus, autoRefresh]);

    const handleRefresh = () => {
        getStatus()
    }

    const handleAction = (userGuid, actionType) => {
        console.log(`Required ${actionType} for ${userGuid}`)
        try {
            wsClient.publish(`company/${companyGuid}/health/${userGuid}/config`, JSON.stringify(actionType))
        } catch (err) {
            console.error(`Error trying to publish mqtt command`)
        }
    }


    let content = (
        <>
            <div className="d-flex justify-content-end mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={autoRefresh}
                    onChange={() => setAutoRefresh(!autoRefresh)}
                />
                <label className="form-check-label ms-2">Auto-Refresh <span className="text-muted">{refreshSeconds}s</span></label>
            </div>
            {
                statusesIsSuccess &&
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mb-4">
                    {statuses.map((dataItem) => (
                        <HealthRealtTimeCard
                            key={dataItem.user.guid + dataItem.lastUpdate} // Aggiungi una chiave unica
                            healthData={dataItem}
                            onAction={handleAction}
                        />
                    ))}
                    {statuses.length == 0 && <NoData />}
                </div>
            }

            {/* <hr className="mx-4" />
            <HealthMockedStatuses /> */}
        </>
    )

    return (
        <PageLayout
            pageTitle={t("health:menu.real_time")}
            isLoadingPage={statusesIsLoading}
            onPageRefresh={handleRefresh}
            bodyContent={content}
        />
    );
};

export default HealthDashboard;
